import { render, staticRenderFns } from "./Lightbox.vue?vue&type=template&id=bcb0d2b2&scoped=true"
import script from "./Lightbox.js?vue&type=script&lang=js&external"
export * from "./Lightbox.js?vue&type=script&lang=js&external"
import style0 from "./Lightbox.scss?vue&type=style&index=0&id=bcb0d2b2&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcb0d2b2",
  null
  
)

export default component.exports